import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccessRestrictedRoutingModule } from './access-restricted-routing.module';
import { AccessRestrictedComponent } from './access-restricted.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    AccessRestrictedComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccessRestrictedRoutingModule
  ]
})
export class AccessRestrictedModule { }
